import FilterBoxContainer from './FilterBoxContainer';

export default FilterBoxContainer;
